
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { store, ShopModule } from "@returns-centre/store";
import { getModule } from "vuex-module-decorators";

@Component
export default class AppCreditAmountContainer extends Vue {
    @Prop({ default: '0.00'}) amount!: number|string;
    @Prop({ default: false}) negative!: boolean;
    shopModule = getModule(ShopModule, store);
}
